import { element } from "prop-types";
import React from "react";
const BPKDrive = React.lazy(() => import('./NewBPKDrive'));
const FormBPKDrive = React.lazy(() => import('./Form'));
const FormTindakLanjut = React.lazy(() => import('./Form/TindakLanjut'));
const FormDisposisi = React.lazy(() => import('./Form/Disposisi'));
const FormDisposisiPermindok = React.lazy(() => import('./Form/DisposisiPermindok'));
const DetailBPKDrive = React.lazy(() => import('./Detail'));

export const newbpkDriveConfigs = [
    {
        path: '/apps/bpk-drive',
        element: <BPKDrive />,
        roleAccess: ['BPK_DRIVE_INTERNAL_ESELON_1', 'BPK_DRIVE_INTERNAL_ESELON_2', 'BPK_DRIVE_EXTERNAL']
    },
    {
        path: '/apps/bpk-drive/:type',
        element: <BPKDrive />,
        roleAccess: ['BPK_DRIVE_INTERNAL_ESELON_1', 'BPK_DRIVE_INTERNAL_ESELON_2', 'BPK_DRIVE_EXTERNAL']
    },
    {
        path: '/apps/bpk-drive/:type/:monitoring',
        element: <BPKDrive />,
        roleAccess: ['BPK_DRIVE_INTERNAL_ESELON_1', 'BPK_DRIVE_INTERNAL_ESELON_2', 'BPK_DRIVE_EXTERNAL' ]
    },
    {
        path: '/apps/bpk-drive/:type/tambah',
        element: <FormBPKDrive />,
        roleAccess: ['BPK_DRIVE_INTERNAL_ESELON_1', 'BPK_DRIVE_INTERNAL_ESELON_2', 'BPK_DRIVE_EXTERNAL' ]
    },
    {
        path: '/apps/bpk-drive/:type/detail/:id',
        element: <DetailBPKDrive />,
        roleAccess: ['BPK_DRIVE_INTERNAL_ESELON_1', 'BPK_DRIVE_INTERNAL_ESELON_2', 'BPK_DRIVE_EXTERNAL' ]
    },
    {
        path: '/apps/bpk-drive/:type/detail/:id/:monitoring',
        element: <DetailBPKDrive />,
        roleAccess: ['BPK_DRIVE_INTERNAL_ESELON_1', 'BPK_DRIVE_INTERNAL_ESELON_2', 'BPK_DRIVE_EXTERNAL' ]
    },
    {
        path: '/apps/bpk-drive/:type/detail/:id/tindak-lanjut/:recipient',
        element: <FormTindakLanjut />,
        roleAccess: ['BPK_DRIVE_INTERNAL_ESELON_1', 'BPK_DRIVE_INTERNAL_ESELON_2', 'BPK_DRIVE_EXTERNAL' ]
    },
    {
        path: '/apps/bpk-drive/:type/detail/:id/tindak-lanjut/:recipient/:forwardId',
        element: <FormTindakLanjut />,
        roleAccess: ['BPK_DRIVE_INTERNAL_ESELON_1', 'BPK_DRIVE_INTERNAL_ESELON_2', 'BPK_DRIVE_EXTERNAL' ]
    },
    {
        path: '/apps/bpk-drive/:type/detail/:id/disposisi',
        element: <FormDisposisi />,
        roleAccess: ['BPK_DRIVE_INTERNAL_ESELON_1', 'BPK_DRIVE_INTERNAL_ESELON_2', 'BPK_DRIVE_EXTERNAL' ]
    },
    {
        path: '/apps/bpk-drive/permintaan-dokumen/detail/:id/disposisi',
        element: <FormDisposisiPermindok />,
        roleAccess: ['BPK_DRIVE_INTERNAL_ESELON_1', 'BPK_DRIVE_INTERNAL_ESELON_2', 'BPK_DRIVE_EXTERNAL' ]
    },
    {
        path: '/apps/bpk-drive/:type/detail/:id/:filter',
        element: <DetailBPKDrive />,
        roleAccess: ['BPK_DRIVE_INTERNAL_ESELON_1', 'BPK_DRIVE_INTERNAL_ESELON_2', 'BPK_DRIVE_EXTERNAL' ]
    },
    {
        path: '/apps/bpk-drive/:type/edit/:id',
        element: <FormBPKDrive />,
        roleAccess: ['BPK_DRIVE_INTERNAL_ESELON_1', 'BPK_DRIVE_INTERNAL_ESELON_2', 'BPK_DRIVE_EXTERNAL' ]
    },
    {
        path: '/apps/bpk-drive/:type/edit/:id/:filter',
        element: <FormBPKDrive />,
        roleAccess: ['BPK_DRIVE_INTERNAL_ESELON_1', 'BPK_DRIVE_INTERNAL_ESELON_2', 'BPK_DRIVE_EXTERNAL' ]
    },
];